import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';
import {
  Button,
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  Text,
} from '@kanda-libs/ks-design-library';

import PageTitle from 'components/shared/PageTitle';

import AddCompanyFields from './Fields';
import { ADD_COMPANY_FORM_ID } from './constants';
import useAddCompanyPage from './useAddCompanyPage';

const AddCompanyPage: React.FunctionComponent = function () {
  const { form, onSubmit, isLoading } = useAddCompanyPage();

  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Add company</PageTitle>
        <div className="w-full max-w-160 mx-auto">
          <Text
            text="Create a verified company directly. Directors are backfilled from Companies House and the owner is emailed a set-password invite."
            className="text-14-22 text-neutral-600 mb-6"
          />
          <Form
            id={ADD_COMPANY_FORM_ID}
            form={form}
            onSubmit={
              onSubmit as (data: StringIndexedObject, e?: unknown) => void
            }
          >
            <FormTheme variant="streamline">
              <AddCompanyFields />
              <Button.Text
                submit
                id="staff-add-company-submit"
                label="Create company"
                isLoading={isLoading}
                className="mt-8"
              />
            </FormTheme>
          </Form>
        </div>
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default AddCompanyPage;
